export const formatCompanyName = (companyName: string | undefined): string => {
  if (!companyName) return 'N/A';

  const name = companyName.trim();

  // Caso 1: "PLV03 - 12 FONSECA MOTOS LTDA" → "PLV03"
  const plvMatch = name.match(/^(PLV\d+)/i);
  if (plvMatch) {
    return plvMatch[1].toUpperCase();
  }

  // Caso 2: "LOCAVIBE LOCAÇÕES LTD" → "LOCAVIBE"
  if (name.toUpperCase().startsWith('LOCAVIBE')) {
    return 'LOCAVIBE';
  }

  // Caso 3: Outros casos → primeira palavra
  return name.split(' ')[0];
};
